import React, { Component } from 'react'
import ReactPlayer from "react-player";

export default class KnowledgeDetailVideo extends Component {
  constructor(props) {
    super(props);
  this.state = {
    isPlay: props.playVid
  };
  this.onPlay = this.onPlay.bind(this);
  this.onPause = this.onPause.bind(this);
}

componentDidUpdate(prevProps) {
  //console.log(prevProps)
  //console.log(this.props)
  //this.setState({isPlay: false})
  if (prevProps.currentVideoSlide != this.props.currentVideoSlide) {
    console.log('false')
    this.setState({isPlay: false})
  }
}

onPlay(){
  console.log('play')
  this.setState({isPlay: true})
}


onPause(){
  console.log('pause')
  this.setState({isPlay: false})
}

  render() {

    return (
      <div>
        <ReactPlayer
            url={this.props.url}
            width={"100%"}
            height={200}
            light={true}
            style={{ marginTop: "0px" }}
            playing={this.state.isPlay}
            onPlay={this.onPlay}
            onPause={this.onPause}
            // playing={this.state.playing}
            //onPlay={() => this.setState({ isPlay: true })}
            //onPause={() => this.setState({ isPlay: false })}
            controls={true}
          />
      </div>
    )
  }
}
